import * as React from "react";

export class HamburgerNavigationIcon extends React.Component<{
    iconId?: number, // image ID from CMS
    modifier?: string, // contextual icon class
    cmsClass?: string // icon class from CMS
}, {}> {
    constructor(props) {
        super(props)
    }

    render() {
        const iconStyles = this.props.iconId
            ? { backgroundImage: `url(/img/${this.props.iconId}/icon.png)` }
            : { };

        const modifier = this.props.modifier ? this.props.modifier : "";
        const cmsClass = this.props.cmsClass ? this.props.cmsClass : "";

        const classNames = `rj-hamburger-icon icon ${modifier} ${cmsClass}`;

        return (
            <span className={classNames} style={iconStyles}></span>
        )
    }
}